import React from 'react';

import OrderProgress from './progress';

const ThankYou = () =>
  <div>
    <OrderProgress active={4} />
    <div style={styles.page}>
      <span className="fa-stack fa-3x">
        <i className="fa fa-certificate fa-stack-2x" />
        <i className="fa fa-check fa-stack-1x fa-inverse" />
      </span>
      <h1>Děkujeme!</h1>
      <span>V nejbližších dnech se Vám ozveme.</span>
    </div>
  </div>;

export default ThankYou;

const styles = {
  page: {
    textAlign: 'center',
    color: 'green',
    marginBottom: 60
  }
};



// WEBPACK FOOTER //
// ./src/browser/Feature/order/thankYou.jsx